'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function countBy(arr, mapper) {
    var result = {};
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var key = mapper(item);
        var _result_key;
        result[key] = ((_result_key = result[key]) !== null && _result_key !== void 0 ? _result_key : 0) + 1;
    }
    return result;
}
exports.countBy = countBy;
